import styled from 'styled-components';

const Title = styled.div`
    margin-bottom: 24px;
    font-size: 36px;
    font-weight: 500;
    color: #787878;
`

export default Title;


// WEBPACK FOOTER //
// ./src/User/dev/Title.js